import { Toaster, ToastPosition } from "react-hot-toast";
import "./PingToaster.scss";

type PingToasterProps = {
  position?: ToastPosition;
};

export const PingToaster = ({ ...rest }: PingToasterProps) => {
  return (
    <Toaster
      {...rest}
      toastOptions={{
        success: {
          duration: 4000,
          className: "PingToaster PingToaster--Success",
        },
        error: {
          className: "PingToaster PingToaster--Error",
        },
        custom: {
          className: "PingToaster PingToaster--Custom",
        },
        loading: {
          className: "PingToaster PingToaster--Loading",
        },
      }}
    />
  );
};
